@if (!!toolbar()) {
    <quill-editor [placeholder]="placeholder()"
                  [modules]="modules()"
                  [ngModel]="value()"
                  [bounds]="bounds()">
    </quill-editor>
}